import {
	WEIGHT_CATEGORY,
	DOMESTIC_PARCEL_OPTIONS,
	INTERNATIONAL_PARCEL_OPTIONS,
	DOMESTIC_LETTER_OPTIONS,
	INTERNATIONAL_LETTER_OPTIONS,
} from '../constants/weightCategories';

function getOptionsFor(service: string, countryCode: string) {
	if (service === 'Parcel' && countryCode === 'IS') return DOMESTIC_PARCEL_OPTIONS;
	if (service === 'Parcel' && countryCode !== 'IS') return INTERNATIONAL_PARCEL_OPTIONS;
	if (service === 'Letter' && countryCode === 'IS') return DOMESTIC_LETTER_OPTIONS;
	if (service === 'Letter' && countryCode !== 'IS') return INTERNATIONAL_LETTER_OPTIONS;
	return null;
}

export function mapWeightToCategory(
	parcelWeight: number,
	service: string,
	countryCode: string
): string {
	if (!parcelWeight || parcelWeight <= 0) return WEIGHT_CATEGORY.UNKNOWN;

	const options = getOptionsFor(service, countryCode);
	if (!options) return '';

	// options must be sorted by weight ascending for this to work
	const match = options.find(o => parcelWeight <= o.weight);
	if (match) return match.value;

	return service === 'Letter' ? options[options.length - 1].value : WEIGHT_CATEGORY.HEAVY;
}

// Returns the category's upper-bound weight so the registration form sends the
// same value as if the user had picked the category directly in the dropdown.
// For weights above all ranges (heavy parcels) the original weight is kept.
export function snapWeightToCategory(
	parcelWeight: number,
	service: string,
	countryCode: string
): number {
	if (!parcelWeight || parcelWeight <= 0) return parcelWeight;

	const options = getOptionsFor(service, countryCode);
	if (!options) return parcelWeight;

	const match = options.find(o => parcelWeight <= o.weight);
	return match && match.weight != null ? match.weight : parcelWeight;
}
